var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1606_10662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1606_10662)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1606_10662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51756 3.02385L1.51745 3.02406C0.469782 4.99652 1.19291 6.9237 2.13871 7.96339C2.13883 7.96353 2.13896 7.96367 2.13909 7.96381L8.10866 14.5089L13.9223 8.02024C14.8198 6.86911 15.1342 5.70702 14.9492 4.40283L14.9492 4.40274C14.6874 2.55519 13.3818 1.2519 11.9275 1.07086C11.0216 0.959358 10.1468 1.24602 9.44364 1.91351C9.25182 2.09572 9.07879 2.3008 8.92651 2.5263L8.11431 3.729L7.27969 2.54175C7.0996 2.28557 6.88778 2.05068 6.64705 1.84138L1.51756 3.02385ZM1.51756 3.02385C2.09494 1.9362 2.96718 1.26439 3.84567 1.07003M1.51756 3.02385L3.84567 1.07003M3.84567 1.07003C4.80006 0.860983 5.81851 1.12197 6.64672 1.84109L3.84567 1.07003Z",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1606_10662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.634299 2.55497C-0.663027 4.99746 0.251068 7.37481 1.39947 8.63684L8.11527 16.0001L14.6891 8.66295C15.7572 7.30556 16.1667 5.86571 15.9393 4.26242C15.625 2.0447 14.026 0.324043 12.0505 0.0784441C10.8388 -0.0709103 9.66851 0.321109 8.75493 1.18848C8.50904 1.42205 8.28939 1.6829 8.09778 1.96665C7.87067 1.64359 7.60421 1.3484 7.30277 1.08637C6.25236 0.174101 4.91516 -0.188281 3.6307 0.0934089C2.41413 0.362188 1.32231 1.2589 0.634299 2.55497Z",
    stroke: "#807D7E",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.3939f01f91152cf5c4fa0233447896b5.svg";
export { ForwardRef as ReactComponent };